import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Pocket, useIsFocused, useOnUserSelected } from '@pelotoncycle/waffles';
import React from 'react';
import { MediumButton } from '@webtv/buttons';
import { Copy } from '@webtv/copy-provider';
import { focusClass } from '@webtv/global-styles';
import { useGetLocale, DateTime, useTLD } from '@webtv/internationalize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TermsTakeoverView = function TermsTakeoverView(_ref) {
  var docsToShow = _ref.docsToShow,
      onContinueSelected = _ref.onContinueSelected,
      logout = _ref.logout;
  var tld = useTLD();
  return /*#__PURE__*/_jsx(Pocket, {
    id: "main",
    vertical: true,
    position: 0,
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Info, {
        children: [/*#__PURE__*/_jsx(Title, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: "terms.updatedTerms"
          })
        }), /*#__PURE__*/_jsx(SubTitle, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: "terms.confirmAgreement"
          })
        }), /*#__PURE__*/_jsx(Details, {
          children: /*#__PURE__*/_jsx(Copy, {
            id: "terms.termLocation",
            tld: tld
          })
        })]
      }), /*#__PURE__*/_jsxs(Actions, {
        children: [docsToShow.map(function (doc, i) {
          return /*#__PURE__*/_jsx(Pocket, {
            id: doc.displayName,
            position: i,
            autofocus: i === 0,
            children: /*#__PURE__*/_jsx(DocLink, _objectSpread({}, doc))
          }, doc.displayName);
        }), /*#__PURE__*/_jsx(Pocket, {
          id: "continue",
          position: docsToShow.length,
          children: /*#__PURE__*/_jsx(Continue, {
            onContinueSelected: onContinueSelected
          })
        }), /*#__PURE__*/_jsx(Pocket, {
          id: "logout",
          position: docsToShow.length + 1,
          children: /*#__PURE__*/_jsx(Logout, {
            logout: logout
          })
        })]
      })]
    })
  });
};

var DocLink = function DocLink(_ref2) {
  var displayName = _ref2.displayName,
      onDocSelected = _ref2.onDocSelected,
      createdAt = _ref2.createdAt;
  var getLocale = useGetLocale();
  var isFocused = useIsFocused();
  useOnUserSelected(onDocSelected);
  return /*#__PURE__*/_jsxs(TermsLinkContainer, {
    className: cx(isFocused && focusClass),
    children: [/*#__PURE__*/_jsx(DocTitle, {
      children: displayName
    }), /*#__PURE__*/_jsx(DocDate, {
      children: DateTime.toLocalizedSlashedDate(createdAt, getLocale)
    })]
  });
};

var Continue = function Continue(_ref3) {
  var onContinueSelected = _ref3.onContinueSelected;
  var isFocused = useIsFocused();
  useOnUserSelected(onContinueSelected);
  return /*#__PURE__*/_jsx(ContinueButton, {
    className: cx(isFocused && focusClass),
    children: /*#__PURE__*/_jsx(Copy, {
      id: "terms.continue"
    })
  });
};

var Logout = function Logout(_ref4) {
  var logout = _ref4.logout;
  var isFocused = useIsFocused();
  useOnUserSelected(logout);
  return /*#__PURE__*/_jsx(LogoutLink, {
    className: cx(isFocused && focusClass),
    children: /*#__PURE__*/_jsx(Copy, {
      id: "terms.logout"
    })
  });
};

var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1tlhjuc"
});
var Info = /*#__PURE__*/styled("div")({
  name: "Info",
  class: "i1i7ub3n"
});
var Actions = /*#__PURE__*/styled("div")({
  name: "Actions",
  class: "a1uc2vys"
});
var TermsLinkContainer = /*#__PURE__*/styled("div")({
  name: "TermsLinkContainer",
  class: "t1gkzn1x"
});
var Title = /*#__PURE__*/styled("div")({
  name: "Title",
  class: "t17oq36x"
});
var SubTitle = /*#__PURE__*/styled("div")({
  name: "SubTitle",
  class: "s1vhj395"
});
var Details = /*#__PURE__*/styled("div")({
  name: "Details",
  class: "d154o2h6"
});
var DocTitle = /*#__PURE__*/styled("div")({
  name: "DocTitle",
  class: "dmz63as"
});
var DocDate = /*#__PURE__*/styled("div")({
  name: "DocDate",
  class: "d1l4kv5t"
});
var ContinueButton = /*#__PURE__*/styled(MediumButton)({
  name: "ContinueButton",
  class: "c1grp0t6"
});
var LogoutLink = /*#__PURE__*/styled("div")({
  name: "LogoutLink",
  class: "l1lqr8si"
});

require("../../../../apps/tv/.linaria-cache/packages/@webtv/terms/ui/TermsTakeoverView.linaria.module.css");